import httpService from '@/services/httpService'

export const types = {
  SET_CATEGORIES: 'category/SET_CATEGORIES',
  SET_SETTINGS: 'category/SET_SETTINGS'
}

const state = {
  categories: [],
  settings: {}
}

const mutations = {
  [types.SET_CATEGORIES]: function (state, categories) {
    state.categories = categories
  },
  [types.SET_SETTINGS]: function (state, settings) {
    state.settings = settings
  }
}

const actions = {
  validate: async function ({ commit, dispatch }, params) {
    const response = await httpService.get(`/category/validate`, { params })
    if (!response) {
      return {}
    }
    return response.data
  },
  getCategoryData: async function ({ commit }, params) {
    const response = await httpService.get('/category', { params })
    if (!response || !response.data) {
      return {}
    }
    commit(types.SET_CATEGORIES, response.data)
    return response.data
  },
  createCategory: function ({ commit }, params) {
    return httpService.post('/category', params,
      { successMessage: 'Category successfully created', raiseError: true, cancelErrorMessage: true })
  },
  updateCategory: function ({ commit }, params) {
    return httpService.patch('/category', params,
      { successMessage: 'Category successfully updated', raiseError: true, cancelErrorMessage: true })
  },
  removeCategory: function ({ commit }, params) {
    return httpService.delete('/category', {
      params,
      successMessage: 'Category successfully removed',
      raiseError: true,
      cancelErrorMessage: true
    })
  },
  getCategorySettings: async function ({ commit, dispatch }) {
    const response = await httpService.get('/category/settings')
    if (!response || !response.data) {
      return
    }
    commit(types.SET_SETTINGS, response.data)
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
